/**
  Function to format the data id
  @function formatFoobarId
  @param {String} id
  @returns {String}
*/
export const formatFoobarId = id => {
  return `/foo/bar/${id}`;
};

/**
  Function to format data for referencing
  @function formatFoobarReference
  @param {String} href
  @returns {Object} { href, desc }
*/
export const formatFoobarReference = href => {
  return {
    href: href,
    desc: ''
  };
};

/**
  Function to extract data from a reference
  @function extractFoobarReference
  @param {Object} reference { href, desc }
  @returns {String} extracted id
*/
export const extractFoobarReference = reference => {
  if (reference && reference.href) {
    let foobarRegex = /\/([^/]*)$/i.exec(reference.href);
    return foobarRegex[1] || '';
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/utils/foobar/index.js